'use client'

import { cx } from 'utils/cx'

import type { SizesContextType } from '../../../contexts/SizesProvider/SizesProvider'
import type { CommonProps } from '../../../types/CommonProps'
import { SizeItem } from '../SizeItem'
import { ITEM_SIZES } from '../SizeItem/SizeItem'
import { getListHeight } from '../utils/getListHeight'

import styles from './SizesList.module.scss'

type SizesListProps = Pick<CommonProps['color'], 'sizes'> & {
	selectedSize: SizesContextType['selectedSize']
	withSheet?: boolean
}

export function SizesList({
	selectedSize,
	sizes,
	withSheet,
}: SizesListProps): React.ReactNode {
	const itemHeight = withSheet ? ITEM_SIZES.SHEET : ITEM_SIZES.ACCORDION

	const listHeight = getListHeight({
		itemHeight,
		isSelectedSize: !!selectedSize,
		sizesLength: sizes.length,
	})

	const showFullList = withSheet || !selectedSize

	return (
		<ol
			className={cx(
				styles.sizesList,
				selectedSize && styles.sizesListUnselect,
				withSheet && styles.borderedChildren,
				!withSheet && styles.sizesListScrollable
			)}
			style={
				{
					'--list-height': listHeight,
				} as React.CSSProperties
			}
			aria-describedby='pdp.sizesSelector'
		>
			{!showFullList && (
				<li className={styles.listItem}>
					<SizeItem
						size={selectedSize}
						extraInfoLayout='row'
						itemHeight={itemHeight}
						withArrow
						isUnselectable
					/>
				</li>
			)}
			{showFullList &&
				sizes.map((size) => {
					return (
						<li className={styles.listItem} key={size.label}>
							<SizeItem
								size={size}
								extraInfoLayout={withSheet ? 'column' : 'row'}
								itemHeight={itemHeight}
								withSheet={withSheet}
							/>
						</li>
					)
				})}
		</ol>
	)
}
